import script from "./InstallDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstallDialog.vue?vue&type=script&setup=true&lang=ts"

import "./InstallDialog.vue?vue&type=style&index=0&id=a1a3198c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1a3198c"]])

export default __exports__